/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { DeviceService } from '@hems/service/src/api/device/DeviceService';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import type { StatusCodeValueType } from '@hems/util/src/exception/exception';

import type { CommonAPIResponse } from 'hems';

export default class DeviceServiceAdmin extends DeviceService {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** Site 삭제 */
  deleteSite = async (siteId: number): Promise<StatusCodeValueType> => {
    const { status } = await this.deleteNew<CommonAPIResponse>(apiWrapper.managerApiV1(`/sites/${siteId}`));

    return status;
  };
}
